import * as Sentry from "@sentry/react";

import { LoginDriver, LoginExped } from "@/store/apis/nextcargo";
import { isLoginExpedResult } from "@/store/slices/auth/auth.guards";

export function initMonitoring() {
  const enabled = import.meta.env.PROD && !!import.meta.env.VITE_GLITCHTIP_DSN;
  console.log({ enabled });

  if (!enabled) return;

  Sentry.init({
    dsn: import.meta.env.VITE_GLITCHTIP_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.75,
    environment: import.meta.env.MODE,
    denyUrls: [/extensions\//i, /^chrome:\/\//i, /moz-extension/i],
    beforeSend(event, hint) {
      const error = hint.originalException;
      const frames = event.exception?.values?.[0]?.stacktrace?.frames;

      if (frames?.some((f) => f.filename?.includes("node_modules"))) {
        return null;
      }

      if (error instanceof TypeError) {
        if (error.message.includes("Cannot read properties of undefined")) {
          return null; // não envia
        }

        if (error.message.includes("Manifest fetch from")) {
          return null; // não envia
        }
      }

      return event;
    }
  });

  window.addEventListener("error", (event) => {
    Sentry.captureException(event.error);
  });

  window.addEventListener("unhandledrejection", (event) => {
    Sentry.captureException(event.reason);
  });
}

export function handleUserMonitoring(user: LoginExped["result"] | LoginDriver["result"]) {
  Sentry.setTag("user_id", user.id);
  Sentry.setTag("company_id", user.company.id);
  Sentry.setTag("role", isLoginExpedResult(user) ? user.role : "driver");
  Sentry.setUser({
    id: user.id,
    username: isLoginExpedResult(user) ? user.user : user.name
  });
  Sentry.setContext("user_data", {
    id: user.id,
    username: isLoginExpedResult(user) ? user.user : user.name,
    company: user.company,
    role: isLoginExpedResult(user) ? user.role : "driver",
    from: isLoginExpedResult(user) ? "expedition" : "driver"
  });
}
